import inDOM from 'dom-helpers/util/inDOM';
import { BREAKPOINT_CHANGED, BREAKPOINT_UNCHANGED_AT_HYDRATION } from '../actions';
import { current } from '../styles/breakpoints';

const initialState = {
  breakpoint: current(),
  breakpointSet: inDOM,
};

const layout = (state = initialState, action) => {
  switch (action.type) {
    case BREAKPOINT_CHANGED:
      return {
        ...state,
        breakpoint: action.payload.breakpoint,
        breakpointSet: true,
      };
    case BREAKPOINT_UNCHANGED_AT_HYDRATION:
      return {
        ...state,
        breakpointSet: true,
      };

    default:
      return state;
  }
};

export default layout;
